module.exports = __webpack_public_path__ + "static/media/sophie.43c16240.png";